import React from 'react';
import { Link } from 'react-router-dom';

function Ayurveda() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Ayurveda, Yoga & Holistic Wellness Tourism Guide: Discover Traditional Healing Abroad
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          In an era dominated by high-stress environments and chronic lifestyle diseases, global travelers are increasingly looking up alternative, preventative healthcare choices. Traditional holistic wellness pathways offer a profound method to rejuvenate the mind and body. 
          By utilizing independent informational directories like <strong>Medical Trip World</strong>, international wellness tourists can explore top certified traditional centers, compare standard healing modalities, and discover customized alternative care packages safely.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Wellness Resource Guides & Cost Tools →
        </Link>
      </div>

      {/* SECTION 1: OVERVIEW OF CORE MODALITIES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Core Alternative Modalities: Panchakarma, Yoga, and Naturopathy
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          When researching global destinations for dedicated natural therapies, wellness travelers encounter highly structured, ancient detoxification regimens tailored to individual constitutional profiles:
        </p>
        <ul style={{ paddingLeft: '20px', color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <li>
            <strong>Panchakarma Detoxification:</strong> A comprehensive five-step metabolic purification process involving therapeutic oil massages (Abhyanga), specialized herbal steam treatments, and targeted dietary cleanses to eliminate deep-seated bodily toxins.
          </li>
          <li>
            <strong>Therapeutic Yoga & Meditation:</strong> Asynchronous physical postures, breath control exercises (Pranayama), and mindfulness protocols designed to regulate neural pathways, lower cortisol, and rebuild muscle flexibility.
          </li>
          <li>
            <strong>Holistic Naturopathy:</strong> Evidence-backed non-invasive therapies utilizing fundamental elements—including hydrotherapy, herbal poultices, and intensive nutritional counseling—to stimulate the body's innate self-healing mechanisms.
          </li>
        </ul>
      </section>

      {/* SECTION 2: TIMELINE AND PLANNING PROFILE */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Planning Your Itinerary: Typical Wellness Stay Profiles
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Unlike rapid outpatient surgeries, authentic holistic care requires structured time-blocks for optimal biological assimilation. The timelines outlined below reflect common industry parameters across premier traditional wellness retreats:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📋 Standard Wellness Retreat Checkpoints:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li><strong>7-Day Rejuvenation Block:</strong> Ideal for corporate burnout management, preventative stress relief, basic dietary transitions, and introductory lifestyle modification seminars.</li>
            <li><strong>14-Day Chronic Care System:</strong> The baseline standard required for mild inflammatory issues, basic metabolic correction, deep tissue detoxification, and targeted therapeutic yoga protocols.</li>
            <li><strong>21 to 28-Day Comprehensive Panchakarma:</strong> Recommended for severe neuromuscular disorders, advanced joint management, intensive systemic purification, and comprehensive post-op biological rehabilitation.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: ACCREDITATION & QUALITY EVALUATION - ADAPTIVE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          How to Verify Authenticity at Traditional Healing Facilities
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates purely as an open informational venue and independent index, we strongly advocate that wellness tourists self-verify destinations by checking official governmental and international quality stamps before reserving an itinerary:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>National Standards (NABH & AYUSH)</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Verify whether the destination center holds dedicated national accreditation scores (such as the AYUSH certifications in India). These metrics ensure the facility employs certified doctors holding formal university degrees in alternative systems of medicine.
            </p>
          </div>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Herbal Raw Material Quality</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Premier alternative healing hubs maintain independent organic herbal gardens or source oils that pass verified heavy metal clearance protocols to ensure toxicological safety for international consumers.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e0e0e0', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem' }}>
          Frequently Asked Questions (FAQs) – Wellness Travel
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Can I combine a wellness retreat with conventional medical treatments?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Many modern facilities coordinate integrative medical programs. However, patients transitioning from major surgical interventions must obtain formal cross-clearance from their primary cardiothoracic or orthopedic team before initiating active thermic therapies or deep tissue massages.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>What type of visa is required to attend traditional therapy centers?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Depending on the host country, travelers can enter using standard tourist documentation for shorter stays. For intensive, long-term programs at accredited clinical centers, standard national Medical Visas provide the correct, legal travel configuration.
          </p>
        </div>
        
        <div style={{ marginBottom: '5px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Does Medical Trip World sell predefined holistic retreat packages?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not sell commercial packages, curate legal agreements, or hold corporate partnerships or MOUs with wellness centers. All bookings, diagnostic reviews, and pricing arrangements take place directly between the traveler and the certified venue.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Begin Compiling Your Alternative Health Homework Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <style>{`
            @media (max-width: 550px) {
              .footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
            }
          `}</style>
          <Link to="/submit-query" className="footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Ayurveda;